import { render, staticRenderFns } from "./ImportMicrosoftContacts.vue?vue&type=template&id=5a668d31&scoped=true&"
import script from "./ImportMicrosoftContacts.vue?vue&type=script&lang=js&"
export * from "./ImportMicrosoftContacts.vue?vue&type=script&lang=js&"
import style0 from "./ImportMicrosoftContacts.vue?vue&type=style&index=0&id=5a668d31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a668d31",
  null
  
)

export default component.exports